import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { defaultTemplate } from 'core/hoc';
import { BaasicDropdown } from 'core/components';
import { isSome, renderIf, uuid } from 'core/utils';
import { Tooltip as ReactTooltip } from "react-tooltip";
import { observer } from 'mobx-react';

const BaasicFieldDropdownTemplate = function ({ /*customRef,*/ focused, disabled, store, field, multi, className, itemRender, valueRender, tagRender, t, labelDisplayed = true, allowEmpty = false, autoClose = false, showChangeFlag = false, previousValue = '', toolTipPlace = 'top',  isNiko = false, nikoInputData, trimOnPaste = true }) {
    // Strip `label` from field.bind() — Kendo v14 treats it as a floating-label
    // trigger that wraps the widget in `.k-floating-label-container` and
    // duplicates the label we already render in `.form__group__label`.
    const { label: _ignoredLabel, ...fieldBindProps } = field.bind();

    function onChange(event) {
        const value = event.target.value;
        if (value) {
            if (store.options.multi) {
                field.set(value);
                if (value.length === 0) {
                    field.showErrors(true);
                }
            } else {
                field.set(value[store.options.dataItemKey]);
            }
        }
        store.onChange(value);
    }

    const TooltipContent = observer(({ initianValue, history, fieldName }) => {
        if (!history || history.fieldName !== fieldName) return null;

        const date = new Date(history.eventDate + "Z");
        const formattedDate = date.toLocaleString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
        }).replace(',', '');

        return (
        <div>
            <div>Previous: {initianValue ? initianValue : 'blank'}</div>
            <div style={{ fontSize: '11px', opacity: 0.75 }}>
            {history ? history.userName + ', ' + formattedDate : '—'}
            </div>
        </div>)
    });

    const requiredMark = field.rules && field.rules.indexOf('required') !== -1 ? <span className="validation__mark">*</span> : null;
    const warningClasses = classNames({
        'input--warning': !field.isValid && field.touched && !field.isDirty
    });

    store.options.disabled = disabled || field.disabled;
    const tooltipId = uuid();
    return (
        <div>
            {labelDisplayed && <div className='form__group__label'>{t(field.label)}{requiredMark}</div>}
            {(!field.isValid || field.hasError) &&
                renderIf(isSome(field.localizedError))(
                    <div className="validation__message"> <i className="u-icon u-icon--xsml u-icon--warning u-mar--right--tny"></i>{field.localizedError}</div>
                )}
            <div className="u-position--rel">
                {showChangeFlag && (
                    isNiko ? 
                    <React.Fragment>
                            <ReactTooltip positionStrategy="fixed" id={"registerTip" + nikoInputData.fieldName + nikoInputData.patientTemplate.id}  place={toolTipPlace} delayShow={600} render={() => 
                            <TooltipContent initianValue={nikoInputData.initialDisplayName ? nikoInputData.initialDisplayName : nikoInputData.initialValue} history={nikoInputData.item.history} fieldName={nikoInputData.fieldName} /> }/>
                            <i className="input--change--text opacity-50" data-tooltip-id={"registerTip" + nikoInputData.fieldName + nikoInputData.patientTemplate.id} onMouseEnter={async () => await nikoInputData.getFieldHistory(nikoInputData.item, nikoInputData.fieldName, nikoInputData.currentValue)} data-tooltip-content="" ></i>
                    </React.Fragment>
                    :
                    <React.Fragment>
                        <ReactTooltip positionStrategy="fixed" id={"registerTipItemChanged" + tooltipId} place={toolTipPlace} />
                        <i data-tooltip-content={`Previous: ${previousValue ? previousValue : "blank"}`} data-tooltip-id={"registerTipItemChanged" + tooltipId} className='input--change--text' ></i>
                    </React.Fragment>
                )}
                <BaasicDropdown
                    {...fieldBindProps}
                    store={store}
                    placeholder={field.placeholder}
                    value={field.value}
                    onChange={onChange}
                    multi={multi}
                    className={className}
                    warningClassName={warningClasses}
                    itemRender={itemRender}
                    valueRender={valueRender}
                    tagRender={tagRender}
                    focused={focused}
                    autoClose={autoClose}
                    trimOnPaste={trimOnPaste}
                //customRef={customRef}
                />
                {field.value && !multi && allowEmpty &&
                    <button
                        disabled={store.options.disabled || disabled}
                        className='k-clear-button'
                        onClick={() => {
                            field.value = null;
                            store.onChange(null);
                        }}
                    >
                        <span className="u-icon u-icon--xsml u-icon--close--primary"></span>
                    </button>
                }
            </div>
        </div>
    );
};

BaasicFieldDropdownTemplate.propTypes = {
    store: PropTypes.object.isRequired,
    field: PropTypes.object.isRequired,
    multi: PropTypes.bool,
    className: PropTypes.string,
    itemRender: PropTypes.any,
    valueRender: PropTypes.any,
    tagRender: PropTypes.any,
    t: PropTypes.any,
    labelDisplayed: PropTypes.bool,
    disabled: PropTypes.bool,
    allowEmpty: PropTypes.bool,
    focused: PropTypes.bool,
    autoClose: PropTypes.bool,
    showChangeFlag: PropTypes.bool,
    previousValue: PropTypes.string,
    toolTipPlace: PropTypes.string,
    isNiko: PropTypes.bool,
    nikoInputData: PropTypes.any,
    trimOnPaste: PropTypes.bool,
    //customRef: PropTypes.object
};

export default defaultTemplate(BaasicFieldDropdownTemplate);
